"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeEmailPaneButton = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const uuid_1 = require("uuid");
const useTelemetrySender_1 = require("../../hooks/useTelemetrySender");
const ComposeEmailDialogContainer_1 = require("./ComposeEmailDialogContainer");
const ComposeEmailDialogStyles_1 = require("./ComposeEmailDialogStyles");
function ComposeEmailPaneButton({ contentId, contentType, selectedUserIds, contentLuid }) {
    const [dialogSessionId] = react_1.default.useState((0, uuid_1.v4)());
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const [hasPermission, setHasPermission] = react_1.default.useState(false);
    const [isDialogOpen, setIsDialogOpen] = react_1.default.useState(false);
    const sendDataInImpactAnalysisEmail = (0, useTelemetrySender_1.useTelemetrySender)({
        type: 'impact_analysis_email_sent',
        content_luid: contentLuid,
        content_type: contentType,
        dialog_session_id: dialogSessionId,
        user_count: 0,
    });
    react_1.default.useEffect(() => {
        apiRequests
            .canUserSendImpactAnalysisEmail({ contentId, contentType })
            .then(r => setHasPermission(r))
            .catch(_ => {
            return;
        });
    }, [contentId, contentType, apiRequests]);
    const launchDialog = react_1.default.useCallback(() => {
        setIsDialogOpen(true);
        sendDataInImpactAnalysisEmail();
    }, [sendDataInImpactAnalysisEmail]);
    const closeDialog = () => setIsDialogOpen(false);
    function sendEmailAndCloseDialog(a) {
        apiRequests
            .sendImpactAnalysisEmailAndShowToast({
            contentType,
            contentId,
            subject: a.subjectText,
            body: a.bodyText,
            userIds: Object.keys(selectedUserIds),
        })
            .then(() => closeDialog())
            .catch(() => closeDialog());
    }
    const hasSelection = Object.keys(selectedUserIds).length >= 1;
    const buttonEnabled = hasPermission && hasSelection;
    const tooltipText = !hasPermission
        ? catalog_messages_1.Messages.SendEmailButtonNoPermissions()
        : !hasSelection
            ? catalog_messages_1.Messages.SendEmailButtonNoSelection()
            : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.ButtonWidget, { handleClick: launchDialog, buttonType: widgets_1.ButtonType.Outline, style: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.emailButtonStyle, disabled: !buttonEnabled, testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('compose-button'), title: tooltipText }, catalog_messages_1.Messages.SendEmail()),
        isDialogOpen && (react_1.default.createElement(ComposeEmailDialogContainer_1.ComposeEmailDialogContainer, { selectedUserIds: selectedUserIds, dismissDialog: closeDialog, submitResult: sendEmailAndCloseDialog, contentType: contentType, sendDataInImpactAnalysisEmail: sendDataInImpactAnalysisEmail, dialogSessionId: dialogSessionId, contentLuid: contentLuid }))));
}
exports.ComposeEmailPaneButton = ComposeEmailPaneButton;
//# sourceMappingURL=ComposeEmailPaneButton.js.map